import AgentProfile from 'components/Pages/AgentProfile/AgentProfile';

export default AgentProfile;
